import { render, staticRenderFns } from "./match-data.vue?vue&type=template&id=765c8a24&scoped=true"
import script from "./match-data.vue?vue&type=script&lang=js"
export * from "./match-data.vue?vue&type=script&lang=js"
import style0 from "./match-data.vue?vue&type=style&index=0&id=765c8a24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c8a24",
  null
  
)

export default component.exports